// import * as type from '../../types';

// const initialLoginState = {
//   response: {},
//   loading: false,
//   error: null
// }
// const initialUserState = {
//   response: {},
//   loading: false,
//   error: null
// }
// const initialSignupState = {
//   response: {},
//   loading: false,
//   error: null
// }


// export function loginReducer(state = initialLoginState, action) {
//   switch (action.type) {
//     case type.FETCH_LOGIN:
//       return { ...state, loading: true };

//     case type.FETCH_LOGIN_SUCCESS:
//       localStorage.setItem("loginResponse", JSON.stringify(action.data.data));
//       return {
//         ...state,
//         loading: false,
//         response: action.data.data
//       };

//     case type.FETCH_LOGIN_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: {
//           message: action.message,
//           status: action.status
//         }
//       };

//     case type.FETCH_LOGIN_CLEAR:
//       localStorage.removeItem("loginResponse"); // clear on logout
//       return {
//         ...state,
//         loading: false,
//         response: {}
//       };

//     default:
//       return state;
//   }
// }

// export function userReducer(state = initialUserState, action) {
//   switch (action.type) {
//     case type.SET_USER:
//       return {
//         ...state,
//         loading: false,
//         response: action.data
//       }
//     default:
//       return state
//   }
// }

// export function signupReducer(state = initialSignupState, action) {
//   switch (action.type) {
//     case type.FETCH_SIGNUP_REQUEST:
//       return { ...state, loading: true };

//     case type.FETCH_SIGNUP_SUCCESS:
//       localStorage.setItem("signupResponse", JSON.stringify(action.response));
//       return {
//         ...state,
//         loading: false,
//         response: action.response
//       };

//     case type.FETCH_SIGNUP_FAILURE:
//       return {
//         ...state,
//         loading: false,
//         error: {
//           message: action.message,
//           status: action.status
//         }
//       }

//     case type.FETCH_SIGNUP_CLEAR:
//       localStorage.removeItem("signupResponse"); // clear on logout
//       return {
//         ...state,
//         loading: false,
//         response: {}
//       };

//     default:
//       return state;
//   }
// }
// 


import * as type from '../../types';

const initialLoginState = {
  response: null,
  loading: false,
  error: null,
  // OTP states
  otpSent: false,
  otpLoading: false,
  otpError: null,
  otpResponse: null, // Track full API payload for notifications
};

const initialUserState = {
  response: null,
  loading: false,
  error: null,
};

const initialSignupState = {
  response: null,
  loading: false,
  error: null,
};

export function loginReducer(state = initialLoginState, action) {
  switch (action.type) {
    // --- Standard Password Login ---
    case type.FETCH_LOGIN:
      return { ...state, loading: true, error: null };

    case type.FETCH_LOGIN_SUCCESS:
      localStorage.setItem("loginResponse", JSON.stringify(action.data?.data || action.data));
      return {
        ...state,
        loading: false,
        response: action.data, // Preserve full object (contains .message and .data)
        error: null,
      };

    case type.FETCH_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          message: action.message,
          status: action.status,
        },
      };

    // --- OTP Request Handlers ---
    case type.SEND_OTP_REQUEST:
      return {
        ...state,
        otpLoading: true,
        otpError: null,
        otpResponse: null,
      };

    case type.SEND_OTP_SUCCESS:
      return {
        ...state,
        otpLoading: false,
        otpSent: true,
        otpResponse: action.data || action.response || { success: true, message: "OTP sent successfully" },
        otpError: null,
      };

    case type.SEND_OTP_FAILURE:
      return {
        ...state,
        otpLoading: false,
        otpSent: false,
        otpError: {
          message: action.message,
          status: action.status,
        },
      };

    // --- OTP Verification Handlers ---
   case type.VERIFY_OTP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        otpError: null,
      };

    case type.VERIFY_OTP_SUCCESS:
      localStorage.setItem("loginResponse", JSON.stringify(action.data?.data || action.data));
      return {
        ...state,
        loading: false,
        response: action.data, // Retain raw object for message listener
        error: null,
      };

   case type.VERIFY_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          message: action.message,
          status: action.status,
        },
        otpError: {
          message: action.message,
          status: action.status,
        },
      };

      case type.CLEAR_AUTH_ERRORS:
      return {
        ...state,
        error: null,
        otpError: null,
        response: null,
        otpResponse: null,
        otpSent: false,
      };

    // --- Logout & State Cleanup ---
    case type.FETCH_LOGIN_CLEAR:
      localStorage.removeItem("loginResponse");
      return {
        ...state,
        loading: false,
        response: null,
        error: null,
        otpSent: false,
        otpLoading: false,
        otpError: null,
        otpResponse: null,
      };

    default:
      return state;
  }
}

export function userReducer(state = initialUserState, action) {
  switch (action.type) {
    case type.SET_USER:
      return {
        ...state,
        loading: false,
        response: action.data,
      };
    default:
      return state;
  }
}

export function signupReducer(state = initialSignupState, action) {
  switch (action.type) {
    case type.FETCH_SIGNUP_REQUEST:
      return { ...state, loading: true };

    case type.FETCH_SIGNUP_SUCCESS:
      localStorage.setItem("signupResponse", JSON.stringify(action.response));
      return {
        ...state,
        loading: false,
        response: action.response,
      };

    case type.FETCH_SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          message: action.message,
          status: action.status,
        },
      };

    case type.FETCH_SIGNUP_CLEAR:
      localStorage.removeItem("signupResponse");
      return {
        ...state,
        loading: false,
        response: null,
      };

    default:
      return state;
  }
}